import Vue from "vue";

interface OrderItem {
  orderItemId?: number;
  tag?: {
    tagId?: number;
    chipId?: number;
    textureId?: number;
    glueId?: number;
    materialId?: number;
    labelSizeId?: number;
    antennaSize?: null;
    tagEnvironments?: null;
    name?: string;
    wet?: boolean;
    label?: boolean;
    blackMark?: boolean;
    virtualKnifeMark?: boolean;
    inventory?: number;
    safetyInventory?: number;
    minOrderQuantity?: number;
    maxOrderQuantity?: number;
    display?: boolean;
    pdfName?: string;
    pdfPath?: string;
    imgName?: string;
    imgPath?: string;
    priceRanges?: Array<{ interval: number; price: number }>;
  };
  previewImg?: string;
  path?: string;
  price?: number;
  saleVolume?: number;
  createTime?: string;
  updateTime?: string;
}

interface Cart {
  cart: Array<OrderItem>;
  updated?: number;
  force?: boolean;
  cartLoading?: boolean;
}

const cart = {
  namespaced: true,
  state: {
    cart: [],
    updated: 0,
    force: false,
    cartLoading: true
  } as Cart,
  mutations: {
    setCart(state: Cart, options: Array<OrderItem>) {
      state.cart = options;
    },
    clearCart(state: Cart) {
      state.cart.length = 0;
    },
    setLoading(state: Cart, status: boolean) {
      Vue.set(state, "cartLoading", status);
    },
    setTime(state: Cart) {
      Vue.set(state, "updated", Date.now());
    }
  },
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getCart(context: any, force: boolean) {
      const delta = Date.now() - context.state.updated;
      if (delta < 6000 && !force && !context.state.force) return;
      context.commit("setLoading", true);
      context.commit("clearCart");
      const res = await Vue.prototype.$http.get("orders/cart");
      const cartData = res.data.cart;
      for (const item of cartData) {
        const res = await Vue.prototype.$http.get(
          `orderitems/${item.orderItemId}/preview`
        );
        item.saleVolume =
          item.saleVolume === 0 ? item.tag.minOrderQuantity : item.saleVolume;
        item.previewImg = res.data;
      }
      context.commit("setTime");
      context.commit("setCart", cartData as Array<OrderItem>);
      context.commit("setLoading", false);
    }
  }
};

export default cart;
